module.exports = "<span (click)=\"deleteModel()\" class=\"icon-trash\" style=\"cursor:pointer;\"></span>"